module.exports = __webpack_public_path__ + "img/checklist.2.b782bd0.jpg";